
import { mapActions } from 'vuex'
import Button from '~/components/buttons/Button'
import CartEmpty from '~/components/cart/CartEmpty'
import CartProduct from '~/components/cart/CartProduct'
import Price from '~/components/price/price'
import { isProductSellable } from '~/helpers/shopify/product'
export default {
  components: { CartEmpty, CartProduct, Price, Button },
  inject: ['wording'],
  props: {
    cart: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    products() {
      return this.groupVariantsByProduct()
    },
    saving() {
      if (!this.cart) return 0
      let totalSavings = 0
      this.cart.products.forEach((p) => {
        let savings = 0
        if (p.discountAllocations && p.discountAllocations.length > 0) {
          let ttAlloc = 0
          p.discountAllocations.forEach(({ allocatedAmount }) => {
            ttAlloc = ttAlloc + parseFloat(allocatedAmount.amount)
          })
          totalSavings += ttAlloc
        } else {
          if (p.strikeoutPrice) savings = p.strikeoutPrice - parseFloat(p.price)
          totalSavings += savings * p.quantity
        }
      })
      return totalSavings.toString()
    },
    currency() {
      if (this.$i18n.locale.includes('us')) return 'USD'
      if (this.$i18n.locale.includes('ca')) return 'CAD'
      if (this.$i18n.locale.includes('eu')) return 'EUR'
      else return ''
    },
    locale() {
      return `${this.$i18n.locale.split('-')[0]}_${this.$i18n.locale
        .split('-')[1]
        .toUpperCase()}`
    },
    isSellable() {
      return isProductSellable(this.$i18n.locale, this.$config)
    },
    isFinalSale() {
      return this.cart?.products.some((objet) => objet.isFinalSale === 'true')
    },
  },
  methods: {
    ...mapActions({
      vxGoToCheckout: 'product/goToCheckout',
    }),
    goToCheckout() {
      this.vxGoToCheckout(this.getGAIdSession())
    },
    getGAIdSession() {
      const ga = window[window.GoogleAnalyticsObject]
      if (ga && ga.getAll) {
        return ga.getAll()[0].get('linkerParam')
      } else return null
    },
    groupVariantsByProduct() {
      if (!this.cart || this.cart.products.length === 0) return []
      const listProducts = this.cart.products
      const productsMap = {}
      const sortedList = []
      for (let i = 0; i < listProducts.length; i++) {
        const sku = listProducts[i].sku
        const productId = sku.substring(0, sku.indexOf('-'))
        if (!productsMap[productId]) productsMap[productId] = []
        productsMap[productId].push(listProducts[i])
      }
      Object.keys(productsMap).forEach((productId) => {
        sortedList.push(...productsMap[productId])
      })
      return sortedList
    },
    isDisabledCheckoutButton() {
      if (!this.cart) return true
      else if (this.cart.products && this.cart.products.length === 0)
        return true
      return false
    },
  },
}
